import SaasHeadManage from "./SaasHeadManage";
import SaasHeadPc from "./SaasHeadPc";

export function AISaasTitle(props: any) {
  return <>{!props.isShare ? <SaasHeadManage {...props} /> : <SaasHeadPc {...props} />}</>;
}
